import { useMemo } from 'react';

import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Header } from '@components';
import {
  isCondoWeeksFromPath,
  isCondoWorldFromPath,
  isLuxuryHomesFromPath,
  isThreeDSFromPath,
  isVacationRentalsFromPath,
  Responsive,
  RootState,
} from '@share/utils';
import { isCondoWeeklySpeccialMarketingFromPath, isErrorFromPath, isWidgetFromPath } from '@share/utils';

export function ApplicationHeader() {
  const loginStore = useSelector((state: RootState) => state.loginStore);
  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);

  const { account } = loginStore;
  const { items } = menuStore;

  const history = useHistory();

  const isThreeDS = useMemo(() => isThreeDSFromPath(history), [history]);
  const isWidgetPage = useMemo(() => isWidgetFromPath(history), [history]);
  const isErrorPage = useMemo(() => isErrorFromPath(history), [history]);
  const isVacationRentals = useMemo(() => isVacationRentalsFromPath(history), [history]);
  const isCondoWorldMap = useMemo(() => isCondoWorldFromPath(history), [history]);
  const isCondoWeeks = useMemo(() => isCondoWeeksFromPath(history), [history]);
  const isLuxuryHomes = useMemo(() => isLuxuryHomesFromPath(history), [history]);
  const isCondoWeeklySpecialMarketing = useMemo(() => isCondoWeeklySpeccialMarketingFromPath(history), [history]);

  // Check if Modern template should be used (both SiteId AND OrgId must match)
  const siteId = items?.siteId;
  const organizationId = items?.organizationId;
  const modernHomeTemplateOrgidList = account?.modernHomeTemplateOrgidList;
  const modernHomeTemplateSiteidList = account?.modernHomeTemplateSiteidList;

  const isInModernOrgId = modernHomeTemplateOrgidList?.includes(organizationId?.toString() as string);
  const isInModernSiteId = modernHomeTemplateSiteidList?.includes(siteId?.toString() as string);

  const useModernTemplate = account?.isRSITemplate && (
    (isInModernOrgId && isInModernSiteId) || 
    (account?.isModernTemplate)
  );

  if (isWidgetPage || isCondoWorldMap || isThreeDS || isCondoWeeks || isLuxuryHomes || isCondoWeeklySpecialMarketing || useModernTemplate) {
    return null;
  }

  return (
    <Responsive>
      <Header isError={isErrorPage} isVacationRentals={isVacationRentals} />
    </Responsive>
  );
}
